import { soundEditionV1_2Abi } from '../../abi/sound-edition-v1_2.mjs';
import { interfaceIds } from '../../constants.mjs';

async function isSoundV1_2_OrGreater({ editionAddress }) {
  return this.instance.idempotentCachedCall(`is-v1_2_or_greater-${editionAddress}`, async () => {
    const { readContract } = await this.expectClient();
    return readContract({
      abi: soundEditionV1_2Abi,
      address: editionAddress,
      functionName: "supportsInterface",
      args: [interfaceIds.ISoundEditionV1_2]
    });
  });
}

export { isSoundV1_2_OrGreater };
